/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { connectEditStakesPopUp } from "./EditStakesPopUp.connect";
import { toastr } from "react-redux-toastr";
import SVG_CloseIcon from "../../../assets/images/svgs/close-dark.svg?react";
import { USER_DATA } from "../../../config/app.config";

const EditStakesPopUp = ({
  user,
  stakes,
  actions,
  open,
 
}) => {
  const isPopUpOpenDispatch = useSelector(
    (state) => state.editStakesPopUp.isOpen
  );

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  //intial three fileds for classic stake
  const [stake, setStake] = useState(
    user.settings.presetStakeSettings.settings
  );
  const [stakeButtons, setStakeButtons] = useState([]);

  // const saveMobileStakesSettings = () => {
  //   actions.requestSaveStakesSettings(user.memberCode, stake);
  // };

  // const handleInputStake = (e, index) => {
  //   e.preventDefault();
  //   const val = Number(e.target.value);
  //   Number.isInteger(val) &&
  //     setStake(() => {
  //       const newStake = [...stake];
  //       newStake[index] = val;
  //       return newStake;
  //     });
  // };

  useEffect(() => {
    setStake(user.settings.presetStakeSettings.settings);
  }, [open]);

  useEffect(() => {
    if (stakes?.length <= 0) {
      actions.requestStakeButtons();
    }
  }, []);

  useEffect(() => {
    if (stakes?.length && !stakeButtons.length) {
      setStakeButtons(stakes);
    }
  }, [stakes, stakeButtons]);

  const handleStakeChange = (e, index) => {
    e.preventDefault();
    const numVal = Number(e.target.value);

    if (Number.isInteger(numVal)) {
      setStakeButtons((prev) => {
        // Condition 1: Value exceeds the maximum limit
        if (numVal > 10000000) {
          toastr.error("", "Value cannot exceed 1,00,00,000.");
          return prev;
        }

        // Check if the max value already exists
        const hasMaxValue = prev.includes(10000000);

        return prev.map((item, i) =>
          i === index
            ? numVal === 10000000
              ? // Condition 2: Attempting to set multiple max values
                hasMaxValue && index !== prev.indexOf(10000000)
                ? (toastr.error("", "Only one value can be 1,00,00,000."), item)
                : numVal
              : numVal
            : item
        );
      });
    } else {
      toastr.error("", "Please enter a valid integer.");
    }
  };

  const handleStakeUpdate = () => {
    if (userData?.is_demo) {
      toastr.error("", "Please login from your read ID.");
      return;
    }

    actions
      .requestUpdateStakeButtons(stakeButtons)
      .then(() => {})
      .catch(() => {});
  };

  return (
    <>
    
      {open && (
        <>
          <div
            className=" absolute top-0 left-0 bottom-0 right-0 h-full w-full z-30 bg-bg_PopUpParentBg flex items-center justify-center font-lato"
            onClick={() => {
              actions.setIsOpen(false);
            }}
          >
            <div
              className="popUpBoxShadow relative origin-center popUpOpenAnimation bg-bg_Quaternary w-[86%] py-3 px-2 rounded "
              onClick={(e) => e.stopPropagation()}
            >
              <h6 className=" text-text_Ternary  text-base font-semibold">
                Edit Stakes
              </h6>
              <span
                className="transition-all ease-in-out duration-200 hover:scale-105 absolute top-2 right-2 cursor-pointer"
                onClick={() => {
                  actions.setIsOpen(!isPopUpOpenDispatch);
                }}
              >
                <SVG_CloseIcon />
              </span>

              <div className=" w-full grid grid-cols-12 gap-2 mt-2">
                {stakeButtons?.length > 0 &&
                  stakeButtons.map((item, index) => {
                    return (
                      <span key={index} className=" col-span-4">
                        <input
                          className="block focus:outline-none text-white  focus:bg-inherit bg-[#141a26]  text-sm text-center border border-quinary rounded-sm py-1 w-full focus:border-secondary"
                          autoComplete="off"
                          type="number"
                          value={item}
                          onChange={(e) => {
                            handleStakeChange(e, index);
                          }}
                        />
                      </span>
                    );
                  })}
              </div>

              <div className=" flex item-center justify-center gap-x-2 mt-2">
                <button
                  className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out  px-2 py-1.5 h-full text-[13px] min-w-16 rounded bg-bg_Quaternary border border-disableBackGroundColorfForPlaceBetBtn text-text_Ternary  font-lato-bold active:scale-75 shadow-[0_2.8px_2.2px_rgba(0,_0,_0,_0.034),_0_6.7px_5.3px_rgba(0,_0,_0,_0.048),_0_12.5px_10px_rgba(0,_0,_0,_0.06),_0_22.3px_17.9px_rgba(0,_0,_0,_0.072),_0_41.8px_33.4px_rgba(0,_0,_0,_0.086),_0_100px_80px_rgba(0,_0,_0,_0.12)]  cursor-pointer"
                  type="button"
                  onClick={() => actions.setIsOpen(!isPopUpOpenDispatch)}
                >
                  Cancel
                </button>
                <button
                  className="  leading-normal relative overflow-hidden  transition duration-150 ease-in-out  px-2 py-1.5 h-full text-[13px] min-w-16 flex items-center justify-center gap-x-1 border border-secondary  rounded bg-bg_Secondary text-text_Quaternary font-lato-bold active:scale-75 shadow-[0_2.8px_2.2px_rgba(0,_0,_0,_0.034),_0_6.7px_5.3px_rgba(0,_0,_0,_0.048),_0_12.5px_10px_rgba(0,_0,_0,_0.06),_0_22.3px_17.9px_rgba(0,_0,_0,_0.072),_0_41.8px_33.4px_rgba(0,_0,_0,_0.086),_0_100px_80px_rgba(0,_0,_0,_0.12)]  cursor-pointer"
                  type="button"
                  onClick={() => {
                    handleStakeUpdate();
                    actions.setIsOpen(!isPopUpOpenDispatch);
                  }}
                >
                  <span>Save</span>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default connectEditStakesPopUp()(EditStakesPopUp);
